import { render, staticRenderFns } from "./album.vue?vue&type=template&id=ddbdd25a&scoped=true"
import script from "./album.vue?vue&type=script&lang=js"
export * from "./album.vue?vue&type=script&lang=js"
import style0 from "./album.vue?vue&type=style&index=0&id=ddbdd25a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbdd25a",
  null
  
)

export default component.exports